import { Order } from '../../../../ts/helpers/Order';
import { OrderKeys } from '../../../../ts/models/OrderKeys';
import { OptionsDictionary } from '../../../../ts/models/sort/SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from '../../../../ts/models/sort/SortOptionsHelper';

export const defaultUserSort = [Order.asc(OrderKeys.displayName)];

export const userSortOptions: OptionsDictionary = {
  'userName': createNonDisplayOptionDefinition('userName', OrderKeys.username),
  'displayName': createNonDisplayOptionDefinition('displayName', OrderKeys.displayName),
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
};
